"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _selectedItemStatusEnum = _interopRequireDefault(require("./selectedItemStatusEnum"));
var _Undo = _interopRequireDefault(require("../../icons/woodmac/Undo"));
var _Trash = _interopRequireDefault(require("../../icons/woodmac/Trash"));
var _Plus = _interopRequireDefault(require("../../icons/woodmac/Plus"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ColumnButtons = function ColumnButtons(_ref) {
  var id = _ref.id,
    status = _ref.status,
    disabled = _ref.disabled,
    onItemWillBeRemoved = _ref.onItemWillBeRemoved,
    onUndoItemWillBeAdded = _ref.onUndoItemWillBeAdded,
    onUndoItemWillBeRemoved = _ref.onUndoItemWillBeRemoved,
    onItemWillBeAdded = _ref.onItemWillBeAdded;
  switch (status) {
    case _selectedItemStatusEnum["default"].WILL_BE_ADDED:
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        type: "button",
        className: "svg-button",
        title: "Undo add",
        disabled: disabled,
        onClick: function onClick() {
          return onUndoItemWillBeAdded(id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Undo["default"], {
        className: "svg-undo add"
      }));
    case _selectedItemStatusEnum["default"].WILL_BE_REMOVED:
    case _selectedItemStatusEnum["default"].WILL_BE_AUTO_REMOVED:
    case _selectedItemStatusEnum["default"].WILL_BE_ADDED_WILL_BE_AUTO_REMOVED:
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        type: "button",
        className: "svg-button",
        title: "Undo remove",
        disabled: disabled,
        onClick: function onClick() {
          return onUndoItemWillBeRemoved(id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Undo["default"], {
        className: "svg-undo remove"
      }));
    case _selectedItemStatusEnum["default"].CAN_BE_ADDED:
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        type: "button",
        className: "svg-button",
        title: "Add",
        disabled: disabled,
        onClick: function onClick() {
          return onItemWillBeAdded(id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Plus["default"], {
        className: "svg-can-add"
      }));
    default:
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        type: "button",
        className: "svg-button",
        title: "Remove",
        disabled: disabled,
        onClick: function onClick() {
          return onItemWillBeRemoved(id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Trash["default"], {
        className: "svg-trash"
      }));
  }
};
var _default = ColumnButtons;
exports["default"] = _default;
ColumnButtons.propTypes = {
  id: _propTypes["default"].string,
  status: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onUndoItemWillBeAdded: _propTypes["default"].func,
  onUndoItemWillBeRemoved: _propTypes["default"].func,
  onItemWillBeRemoved: _propTypes["default"].func,
  onItemWillBeAdded: _propTypes["default"].func
};